<template>
  <a-modal :title="title" :width="900" :visible="visible" @cancel="handleCancel"
    v-if="hackReset">
    <template #footer>
      <a-button style="margin-left: 8px" @click="handleCancel">取消</a-button>
      <a-button v-show="isfoot" type="primary" :loading="confirmLoading" @click="handleEdit">修改</a-button>
    </template>
    <a-form :form="form">
      <a-row :gutter="24">
        <a-col :md="12">
          <a-form-item label="图片名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="record.name" placeholder="请输入图片名称" />
          </a-form-item>
        </a-col>
        <a-col :md="12">
          <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :md="12">
          <a-form-item label="所属平台" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-radio-group name="radioGroup" v-model="record.platform">
              <a-radio value="1">医生端</a-radio>
              <a-radio value="2">药师端</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :md="12">
          <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :md="12">
          <a-form-item label="详细页地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="record.url" placeholder="请输入详细页地址" />
          </a-form-item>
        </a-col>
        <a-col :md="12">
          <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :md="24" style="padding-left:9px;padding-right: 165px;">
          <a-form-item label="权重" :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
            :wrapperCol="{xs: { span: 24 },sm: { span: 14 }}">
            <a-input-number id="inputNumber" v-model="record.weight" :min="1" :max="10" placeholder="请输入权重" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :md="24" style="padding-left:9px;padding-right: 165px;">
          <a-form-item label="上传图片" :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
            :wrapperCol="{xs: { span: 24 },sm: { span: 14 }}">
            <a-upload v-model="form.fileList" name="avatar" list-type="picture-card" class="avatar-uploader"
              :show-upload-list="false" action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              :before-upload="beforeUpload" @change="handleChange">
              <img v-if="record.photoUrl" :src="record.photoUrl" alt="avatar" />
              <div v-else>
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">
                  Upload
                </div>
              </div>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-row>

    </a-form>
  </a-modal>
</template>

<script>
import { pictureEdit } from '@/api/modular/interhospital/picture/pictureMange'
  export default {
    data () {
      return {
        loading: false,
        checked: 0,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 19 }
        },
        form: {},
        visible: false,
        confirmLoading: false,


        title: '',
        isfoot : false,
        parameter : {},
        userDate : '',
        hackReset: true,
        record : {},
      }
    },
    methods: {
      // 初始化方法
      add(record, type) {
        this.record = record;
        this.record.platform = this.record.platform + ''
        this.visible = true;
        if (type == 1) {
          this.title = '查看轮播图';
          this.isfoot = false;
        } else {
          this.title = '编辑轮播图';
          this.isfoot = true;
        }
        
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      onChangebirthday(date, dateString) {
        this.birthdayDateString = dateString
      },
      handleCancel () {
        this.visible = false;
        this.hackReset = false;
        this.$nextTick(()=>{
          this.hackReset = true;
        })
      },
      // 
      handleChange() {

      },
      beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
          this.$message.error('You can only upload JPG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
      },

      // 编辑轮播图
      handleEdit() {
        this.confirmLoading = true;
        let params = {
          id: this.record.id,
          name: this.record.name,
          platform: this.record.platform,
          url: this.record.url,
          weight: this.record.weight,
          photoUrl: this.record.photoUrl,
          orgId: this.record.orgId,
        };
        pictureEdit(params).then(res => {
          this.confirmLoading = false;
          if (res.code == 200) {
            this.$message.success('编辑成功');
            this.$emit('ok')
            this.handleCancel()
          } else {
            this.$message.error('编辑失败');
            this.handleCancel()
          }
        })
      }
    }
  }
</script>
<style lang="less" scoped>
.viewDetial-tiem{
  margin-bottom: 10px;
}
.viewDetial-title{
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
  .viewDetial-title-notes{
    font-weight: 400;
    font-size: 13px;
    color: rgba(127, 127, 127, 0.847058823529412);
    margin-left: 15px;
  }
}
</style>
